
import { Component, Vue } from "vue-property-decorator";
import {
  apiAuthPlatformRuleLists,
  apiAuthPlatformRuleEdit,
  apiAuthPlatformRuleAdd,
  apiAuthPlatformRuleDetail,
} from "@/api/permissions";
import { PageMode } from "@/utils/type";
import { flatten, arrayToTree, treeToArray } from "@/utils/util";
import { MenuEnum } from "@/utils/appEnums";
import elementUiIcon from "@/utils/icon";

@Component
export default class RoleEdit extends Vue {
  /** S Data **/
  mode: string = PageMode.ADD; // 当前页面【add: 添加角色 | edit: 编辑角色】
  identity: number | null = null; // 当前编辑用户的身份ID  valid: mode = 'edit'
  MenuEnum = MenuEnum;
  menuOptions: any = [];
  elementUiIcon = elementUiIcon;
  componentsOptions: any = [];

  // 表单数据
  form: any = {
    // 保存当前菜单的所有父级
    auth_key: "",
    id: "",
    //父级id
    pid: "0",
    //类型
    type: MenuEnum.CATALOGUE,
    //图标
    icon: "",
    //中文名称
    name: "",
    //英文名称
    en_name: "",
    //排序号
    sort: 0,
    // 路由路径
    paths: "",
    //权限链接
    perms: "",
    //前端组件
    component: "",
    //选中路径
    selected: "",
    //模块名
    module_name: "",
    //路由参数
    params: "",
    //是否缓存 0=否， 1=是
    is_cache: 1,
    //是否显示 0=否， 1=是
    is_show: 1,
    //是否禁用 0=否， 1=是
    is_disable: 0,
    redirect: "",
  };

  // 权限树
  permissionsTree: any[] = [];

  // 表单验证
  formRules = {
    pid: [
      {
        required: true,
        message: "请选择父级菜单",
        trigger: ["blur", "change"],
      },
    ],
    zh_cn_name: [
      {
        required: true,
        message: "请输入菜单中文名称",
        trigger: "blur",
      },
    ],
    en_name: [
      {
        required: true,
        message: "请输入菜单英文名称",
        trigger: "blur",
      },
    ],
  };

  /** E Data **/

  /** S Methods **/

  querySearch(queryString: string, cb: any) {
    const results = queryString
      ? this.componentsOptions.filter((item: any) =>
          item.toLowerCase().includes(queryString.toLowerCase()),
        )
      : this.componentsOptions;
    cb(results.map((item: any) => ({ value: item })));
  }

  // 表单提交
  submitForm(formName: string) {
    const ref = this.$refs[formName] as HTMLFormElement;
    ref.validate((valid: boolean) => {
      if (!valid) {
        return this.$message.error("请完善信息");
      }

      // 请求发送
      switch (this.mode) {
        case PageMode.ADD:
          return this.handleRoleAdd();
        case PageMode.EDIT:
          return this.handleRoleEdit();
      }
    });
  }

  // 添加角色
  handleRoleAdd() {
    apiAuthPlatformRuleAdd({
      ...this.form,
      auth_key:
        typeof this.form.pid === "string" || typeof this.form.pid === "number"
          ? this.form.pid
          : this.form.pid.join(","),
      pid:
        typeof this.form.pid === "string" || typeof this.form.pid === "number"
          ? this.form.pid
          : this.form.pid[this.form.pid.length - 1],
    }).then((res) => {
      this.$router.go(-1);
    });
  }

  // 编辑角色
  handleRoleEdit() {
    apiAuthPlatformRuleEdit({
      ...this.form,
      id: this.identity,
      auth_key:
        typeof this.form.pid === "string" || typeof this.form.pid === "number"
          ? this.form.pid
          : this.form.pid.join(","),
      pid:
        typeof this.form.pid === "string" || typeof this.form.pid === "number"
          ? this.form.pid
          : this.form.pid[this.form.pid.length - 1],
    }).then((res) => {
      this.$router.back();
    });
  }

  // 初始化表单数据: 角色编辑
  initFormDataForRoleEdit() {
    apiAuthPlatformRuleDetail({
      id: this.identity,
    }).then((res) => {
      if (res.auth_key) {
        this.form.pid = String(res.auth_key).split(",");
        res.auth_key = this.form.auth_key;
      }
      if (res.component) this.form.component = res.component;
      if (res.en_name) this.form.en_name = res.en_name;
      if (res.icon) this.form.icon = res.icon;
      if (res.id) this.form.id = res.id;
      if (res.hasOwnProperty("is_cache")) this.form.is_cache = res.is_cache;
      if (res.hasOwnProperty("is_disable"))
        this.form.is_disable = res.is_disable;
      if (res.hasOwnProperty("is_show")) this.form.is_show = res.is_show;
      if (res.params) this.form.params = res.params;
      if (res.paths) this.form.paths = res.paths;
      if (res.perms) this.form.perms = res.perms;
      if (res.redirect) this.form.redirect = res.redirect;
      if (res.hasOwnProperty("pid")) this.form.pid = res.pid;
      if (res.hasOwnProperty("selected")) this.form.selected = res.selected;
      if (res.hasOwnProperty("module_name"))
        this.form.module_name = res.module_name;
      if (res.sid) this.form.sid = res.sid;
      if (res.hasOwnProperty("sort")) this.form.sort = res.sort;
      if (res.type) this.form.type = res.type;
      if (res.name) this.form.name = res.name;
    });
  }

  getAuthMenu() {
    const menu: any = { id: "0", name: "顶级", children: [] };
    apiAuthPlatformRuleLists({}).then((res) => {
      menu.children = arrayToTree(
        treeToArray(res.lists).filter(
          (item: any) => item.type != MenuEnum.BUTTON,
        ),
      );
      this.menuOptions.push(menu);
    });
  }

  /** E Methods **/
  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query;
    if (query.mode) {
      this.mode = query.mode;
    }

    if (this.mode === PageMode.EDIT) {
      this.identity = query.id * 1;
      this.initFormDataForRoleEdit();
    }
    this.getAuthMenu();

    //递归获取 views 文件夹下的所有.vue文件
    const files = require.context("@/views", true, /\.vue$/);
    let pages: any = [];
    files.keys().forEach((key) => {
      pages.push(key.replace(/(\.\/|\.vue)/g, ""));
    });
    this.componentsOptions = pages;
  }
  /** S Life Cycle **/
}
